export const FETCH_CONSULT_REQUEST = "FETCH_CONSULT_REQUEST";
